import { Box } from '@mui/material';
import React, { FC } from 'react';
import TimeInput, { parseTimeValue } from 'components/TimeInput/TimeInput';
import { normalizeTime } from './timeslotFormUtils';

type VenueConfigTimeFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  hasError?: boolean;
  size?: 'small' | 'medium';
};

export const VenueConfigTimeField: FC<VenueConfigTimeFieldProps> = ({
  label,
  value,
  onChange,
  onBlur,
  hasError,
  size = 'small',
}) => (
  <Box sx={{ flex: 1, minWidth: 0 }} className="timePicker">
    <TimeInput
      label={label}
      size={size}
      field="time"
      value={parseTimeValue(normalizeTime(String(value ?? '')))}
      hasError={hasError}
      fieldError={hasError}
      textChange={(newValue, _field, inputError) => {
        if (inputError?.error) return;
        const formatted = String(newValue ?? '').trim();
        if (formatted) {
          onChange(formatted);
          onBlur?.();
        }
      }}
    />
  </Box>
);
